import { FC, useContext } from 'react'
import { connectSearchBox } from 'react-instantsearch-dom'
import SearchInput from './SearchInput';
import Pill from 'src/common/Pill';
import { Box, ButtonGroup, Flex } from '@chakra-ui/react';
import { searchConfigContext } from './SearchableFeedProvider';
import { capitalize } from 'src/util';
import { DomainObjects } from 'projectlink-common';
import ButtonSwitch from 'src/common/ButtonSwitch';
import { useRouter } from 'next/router';
import { useAccent2, useBackground } from 'src/modeAwareColors';
import { useLightModeValue } from 'src/util/theme';

const FeedSearchInput = connectSearchBox<any>(SearchInput)

const FilterableSearchInput: FC<any> = ({
  refine,
  initialTopics,
  currentRefinement,
  hideTypes = false,
  hideTopics = false,
  ...rest
}) => {
  const {
    selectedType,
    selectedTopics,
    setSelectedType,
    setSelectedTopics,
  } = useContext(searchConfigContext)

  const router = useRouter()
  const defaultRefinement = (router.query?.query as string || '')

  const isSelected = topic => selectedTopics.some(t => t === topic)

  const setTopic = topic => {
    setSelectedTopics(prev => [...prev, topic])
  }

  const unsetTopic = topic => {
    setSelectedTopics(prevState => prevState.filter(t => t !== topic))
  }

  const onSelect = topic => isSelected(topic)
    ? unsetTopic(topic)
    : setTopic(topic)

  const shadow = useLightModeValue('lg')

  return (
    <Box
      maxW='container.md'
      mx='auto'
      p='base'
      pb={5}
      boxShadow={shadow}
      borderRadius='xl'
      borderColor={useAccent2()}
      borderWidth='1px'
      bg={useBackground()}
      {...rest}
    >
      <FeedSearchInput
        refine={refine}
        borderRadius='md'
        currentRefinement={currentRefinement}
        defaultRefinement={defaultRefinement}
        placeholder='What are you looking for?...'
        mb={4}
      />
      {!hideTypes && (
        <Flex mb={4}>
          <ButtonGroup isAttached>
            <ButtonSwitch
              isSelected={selectedType === null}
              onClick={() => setSelectedType(null)}
            >
              Everything
            </ButtonSwitch>
            <ButtonSwitch
              isSelected={selectedType === DomainObjects.organization}
              onClick={() => setSelectedType(DomainObjects.organization)}
            >
              Companies
            </ButtonSwitch>
            <ButtonSwitch
              isSelected={selectedType === DomainObjects.project}
              onClick={() => setSelectedType(DomainObjects.project)}
            >
              Projects
            </ButtonSwitch>
          </ButtonGroup>
        </Flex>
      )}
      {!hideTopics && (
        <Flex flexWrap='wrap'>
          {initialTopics?.map(t => t.name).sort().map(name => (
            <Pill
              isSelected={isSelected(name)}
              onClick={() => onSelect(name)}
              key={name}
              mr={3}
              mb={3}
            >{capitalize(name)}</Pill>
          ))}
        </Flex>
      )}
    </Box>
  )
}

export default FilterableSearchInput
